import { ApiRequestInterceptor } from "./apiRequest";
import { ORDERS } from "../Constants/Endpoints";

export const fetchInactiveRestaurants = async () => {
    const method = "GET";
    const url = `${ORDERS.activeOrders}`;
    const response = await ApiRequestInterceptor(url, method);

    const status = response?.statusCode ?? response?.code ?? 200;
    const rawBody = response?.body ?? response?.data ?? response;

    let bodyObj;
    try {
        bodyObj = typeof rawBody === "string" ? JSON.parse(rawBody) : rawBody;
    } catch {
        bodyObj = {};
    }

    const restaurants =
        bodyObj?.restaurants ??
        bodyObj?.data?.restaurants ??
        [];
    const count =
        bodyObj?.count ??
        bodyObj?.data?.count ??
        (Array.isArray(restaurants) ? restaurants.length : 0);

    if (status !== 200) {
        throw new Error(bodyObj?.message || `HTTP ${status}`);
    }

    return {
        statusCode: status,
        body: { count, restaurants },
    };
};